import React from 'react'
import styles from './Settings.module.css'
import Form from './Form/Form'
import { useHistory } from 'react-router-dom'
import useAuthUser from '../../hooks/useAuthUser'

const Settings = () => {

    const history = useHistory()
    const authData = useAuthUser()


    if(!authData) {
        history.push('/login')
      }
    

    return (
        <div className={styles.pageContainer}>
           
        <section className={styles.hero}>
            <h1>Profile Settings</h1>
            <div className={styles.paragraph}>
                <p>Edit/ update your business profile</p>
            </div>
        </section>
        <section className={styles.stat}>
        
            <Form user={authData} />
        </section>
       
    </div>
    )
}

export default Settings
